import { useContext, useEffect } from 'react';

import { useSearchParams } from 'next/navigation';

import { RefererContext } from '@/modules/activityTracker/RefererProvider';
import { IS_PLA_REFERER } from '@/modules/product/constants';
import { isPLAReferer } from '@/modules/product/helpers/isPLAReferer';
import { setSessionStorageItem } from '@/modules/storage';

export function useAddIsPLARefererToSessionStorage() {
  const params = useSearchParams();
  const referer = useContext(RefererContext) || null;
  const isFromPLA = isPLAReferer({
    params,
    referer,
  });

  useEffect(() => {
    if (isFromPLA) {
      setSessionStorageItem(IS_PLA_REFERER, 'true');
    }
  }, [isFromPLA]);
}
